export default __webpack_public_path__ + "static/media/file_icon.08c803de.svg";